import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";

export const techMenuResolver: ResolveFn<{ menuId: string | null }> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const menuId: string = 'tech-menu';
    return { menuId };
  };
